import { createFileRoute } from "@tanstack/react-router";

import { OrgPreferencesPage } from "../iam/organization/components/OrgPreferencesPage";

/**
 * Route is /organizations/$organizationId/preferences: the organization preferences
 * page (the embedded-studio defaults). Open to every role — the page renders the
 * defaults read-only for a contributor/viewer and editable for an owner/admin.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/preferences")({
  component: OrgPreferencesPage,
});
